import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { mapActions } from 'vuex'
import api from '../../api'
import { LoginActionPayload } from '../../store/actions'
import * as types from '../../store/types'
import { createMsalClient, setMfaPending, MSAL_SCOPES } from '../../util/msal'

@Component({
  methods: {
    ...mapActions({
      login: types.LOGIN,
      loginAssertion: types.LOGINASSERTION,
    }),
  },
})
export default class LoginView extends Vue {
  login!: (payload: LoginActionPayload) => Promise<account.TCurrent>
  loginAssertion!: (payload: { tenantId: string; idToken: string }) => Promise<account.TCurrent>

  username: string = ''
  password: string = ''
  rememberMe: boolean = false
  errors: string[] = []
  defaultPwd: string = 'ZINUSP@ssw0rd'

  selectedCorp: account.Corporation | null = null;
  mfaEnabled: boolean = true;
  useDeptSelect: boolean = false;

  corporations: account.Corporation[] = [];
  azure!: account.Azure;
  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //

  created() {
    this.getCorporations();
    this.username = localStorage.username
    this.rememberMe = localStorage.rememberMe === 'true'
  }

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

    onChangedCorp(){
        this.errors = [];
        if(this.selectedCorp){
            this.mfaEnabled = this.selectedCorp.mfaEnabled;
        }
    }

    getCorporations(){
        api.auth.getLoginConfig().then((config) => {
             if(config.corporations.length > 0){
                this.corporations = config.corporations;
            }
            else{
                this.mfaEnabled = true;
            }
            this.useDeptSelect = config.corporations.some(s=> !s.mfaEnabled);
            this.azure = config.azure;
        })
    }

  async handleLogin(e: Event) {
    e.preventDefault()
    this.errors = []
    if (!this.azure) return // config not loaded yet
    if(this.useDeptSelect && this.selectedCorp == null){
        this.errors = ['회사를 선택하세요.'];
        return;
    }
    const { returnUrl, ...etc } = this.$route.query
    console.log('returnUrl : ' + returnUrl)

    if(this.mfaEnabled && this.azure){
      try {
        const fromPath = returnUrl && typeof returnUrl === 'string' ? decodeURIComponent(returnUrl) : '/'
        const idToken = await this.initMsal(fromPath)
        if (!idToken) {
          return
        }
        await this.loginAssertion({ tenantId: this.azure.tenantId, idToken })
      } catch (err: any) {
        console.log('msal handleLogin error', err)
        return
      }
    }
    else{
        if (!this.checkForm(e)) throw new Error('[LOGIN_CANCELED_ERROR]');
        const { username, password, rememberMe } = this
        try {
          const result = await this.login({ username, password })
          localStorage.username = rememberMe ? username : ''
          localStorage.rememberMe = rememberMe
        } catch (e) {
          const serverErrors = (e as any).data?.errors
          if (serverErrors) {
            this.errors = [...this.errors, ...serverErrors]
            if (serverErrors[0].indexOf("expired") > -1){
              this.changePassword();
            }
          } else {
            this.errors.push((e as any)?.statusText || 'Unknown Error');
            console.log(e, 'error');
          }
          return
        }
    }

    if (returnUrl && typeof returnUrl === 'string') {
        this.$router.push({
            path: decodeURIComponent(returnUrl),
            query: etc,
        })
    } else {
        this.$router.push({
            path: '/',
            query: etc,
        })
    }
  }

  async initMsal(fromPath: string = '/'): Promise<string | null> {
    const msal = createMsalClient(this.azure.clientId, this.azure.tenantId)

    return await msal
        .handleRedirectPromise()
        .then(async (res: any) => {
            const returnToken: string | null = res?.idToken ?? null
            if (returnToken == null) {
                setMfaPending(this.azure.tenantId, fromPath)
                await msal
                    .loginRedirect({
                        scopes: MSAL_SCOPES,
                        redirectUri: `${window.location.origin}`,
                    })
                    .catch((err: any) => {
                        console.log('msal loginRedirect error', err)
                    })
            }

            return res?.idToken ?? null
        })
        .catch((err: any) => {
            console.log('msal error', err)
            return null
        })
  }

  async checkForm(e: Event): Promise<boolean> {
    this.errors = []

    if (!this.username) {
      this.errors.push('아이디를 입력하세요.')
    }
    if (this.username?.indexOf('@') != -1 && !this.validEmail(this.username)) {
      this.errors.push('올바른 이메일 형식이 아닙니다.')
    } else if (!this.password) {
      this.errors.push('암호가 필요합니다.')
    }
    if (this.password == this.defaultPwd){
      this.errors.push('초기비밀번호입니다. 비밀번호 변경이 필요합니다.');
      await (window as any).alertAsync('초기비밀번호입니다. 비밀번호 변경이 필요합니다.');
      this.changePassword();
    }

    if (this.errors.length) {
      return false
    } else {
      e.preventDefault()
      return true
    }
  }

  validEmail(email: string): boolean {
    var re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
  }

  changePassword() {
    window.open('https://account.activedirectory.windowsazure.com/ChangePassword.aspx')
  }
}
